<template>
  <div :class="{ 'is-selected': selected, 'c-select__option': !props.display }" @click="selectOption()">
    <div class="flex items-center justify-between ">
      <span :class="{ truncate: selected }">
        <span v-if="label" class="label">{{label}}</span>
        <slot :display="props.display" />
      </span>
      <se-icon v-if="selected && !props.display" name="check" :size="24" class="ml-8" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, getCurrentInstance } from 'vue';
import SeIcon from '../icon/Icon';

const props = defineProps<{
  value: string,
  label: string,
  display?: boolean,
}>();

const instance = getCurrentInstance();
const select = instance?.parent;

const selectValue = computed<string>(() => select?.exposed?.selectValue.value);

const selected = computed<boolean>(() => selectValue.value === props.value);

const selectOption = () => {
  select?.exposed?.setValue(props.value);
};
</script>

<script lang="ts">
export default {
  name: 'SeOption',
};
</script>
